export const getOrgRouteTypesUrl = "/api/v3/org/road_stretch/route_type";
